/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum CategoryOptionsReturnCodes {
    CategoryExists = 0,
    Success = 1,
    GenericTab = 2,
    CustomContent = 3,
    Error = 4
}